import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UserHttpService } from ".";
import { CostManagement, CostManagementDetail, HttpResponse } from "../interfaces";

@Injectable({
    providedIn: 'root'
})
export class CostManagementHttpService {

    constructor(
        private http: HttpClient,
        private userSessionService: UserHttpService
    ) {}

    public addCost(body: CostManagement, isEdit: boolean = false): Observable<HttpResponse<number>> {
        const formData = new FormData();
        formData.append('customer_id', this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('employee_id', body.employee_id);
        formData.append('cost_perHour', body.cost_per_hour.toString());

        if (isEdit && body.cost_id) {
            formData.append('cost_id', body.cost_id);
        }

        return this.http.post<HttpResponse<number>>('employees/addEmpCost', formData);
    }

    public getCostList(): Observable<HttpResponse<CostManagementDetail[]>> {
        const formData = new FormData();
        formData.append('customer_id', this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userSessionService.userToken);
        return this.http.post<HttpResponse<CostManagementDetail[]>>('employees/addEmpCost/list', formData);
    }

    public deleteCost(id: string): Observable<HttpResponse<any>> {
        const formData = new FormData();
        formData.append('customer_id', this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('cost_id', id);
        return this.http.post<HttpResponse<any>>('employees/addEmpCost/deleteCost', formData);
    }
}
